import { type RequestStatus, getRequestStatusValue } from "~/tools/request-status";
import { type OperatorFunction, map } from "~/tools/rxjs";

/**
 * Works like rxjs map operator, but on request status values. Error and Loading statuses are still propagated when occur
 *
 * @deprecated avoid using anything related to rxjs
 */
export const mapObservableValue = <E, T, R, M = unknown>(
	project: (value: T) => R,
): OperatorFunction<RequestStatus<E, T, M>, RequestStatus<E, R, M>> =>
	map((status: RequestStatus<E, T, M>) => {
		const value = getRequestStatusValue(status);
		if (value != null) {
			return { ...status, value: project(value) } as RequestStatus<E, R, M>;
		}
		return status as RequestStatus<E, R, M>;
	});
